// @module Ames.HomeStore.HomeStore
define("Ames.StoreEventsCalendar.Details.View", [
  "ames_store_events_details.tpl",

  "Backbone",
], function (
  ames_store_events_details_tpl,

  Backbone
) {
  "use strict";

  // @class Ames.HomeStore.HomeStore.View @extends Backbone.View
  return Backbone.View.extend({
    template: ames_store_events_details_tpl,

    initialize: function (options) {
      this.eventSelected = options.eventSelected;
    },

    events: {},

    bindings: {},

    childViews: {},

    //@method getContext @return Ames.HomeStore.HomeStore.View.Context
    getContext: function getContext() {
      //@class Ames.HomeStore.HomeStore.View.Context

      return {
        description: this.eventSelected.description,
        location: this.eventSelected.storeName,
      };
    },
  });
});
